module.exports = __webpack_public_path__ + "static/media/Thundurus_gaussian2.b5209ca9.png";